import { useEffect, useState } from "react";
import PropertyCard from "./propertyCard";
import { useDispatch } from "react-redux";
import { apiGetProperty } from "api/property";
import PlusIcon from "assets/icons/PlusIcon";
import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Property from "../../assets/images/property.svg";
import AddCard from "components/List/AddCard";
import PropertyIcon from "assets/icons/Property";


const ProductPropertyList = () => {
  const dispatch = useDispatch()
  const [data, setData] = useState([])
  const navigate = useNavigate()

  const getFullData = () => {
    //@ts-ignore
    dispatch(apiGetProperty({
      cb: (res: any) => {
        setData(res.data)
      }
    }))
  }
  useEffect(() => {
    getFullData()

    return () => {

    }
  }, [])

  return (<div className="wrap-shareholder p-2 md:p-4">
    <div className="header-shareholder">
      <div className="header-right">
        <div>ویژگی محصول</div>
        <div>نمایش ویژگی محصول کسب کار</div>
      </div>
      <div className="header-left" />
    </div>
    <div className="body-cards flex flex-col">
      <div className="grid">
        <div className="grid md:grid-cols-4 xs:grid-cols-1 gap-4">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 style-body-card">

            <div
              onClick={() => {
                navigate(`/productsproperty/add`)
              }}
              className="rounded-md aspect-video w-72 border-dashed-gray hover:border-dashed-blue py-5 px-4 transition-all cursor-pointer"

            >
              <div className="bg-white shadow-[0_0_10px_0px_rgba(0,0,0,0.2)] rounded-md h-full w-full flex flex-col gap-4 justify-center items-center">

                <PropertyIcon />

                <div className="flex items-center justify-center gap-2">
                  <PlusIcon color="#1062D0" scale={0.7} />
                  <span className="text-blue-1">اضافه کردن ویژگی</span>
                </div>
              </div>
            </div>
          </div>
          {data.map((property, i) => {
            return (
              <PropertyCard
                getFullData={getFullData}
                property={property}
                index={i + 1}
                key={i}

              />
            );
          })}
        </div>
      </div>
      <div className="col-span-5">
        <div className="row">

        </div>
      </div>
    </div>
  </div >);
}

export default ProductPropertyList;